import { render, staticRenderFns } from "./resumo-socios-table.vue?vue&type=template&id=5b9f330c"
import script from "./resumo-socios-table.vue?vue&type=script&lang=js"
export * from "./resumo-socios-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports